import React from "react";

export const Logo = (props) => {
    let color = props.dark ? "dark" : "light"
    return <img src={`https://client-upload.bytehogs.com/ac/media/${props.mobile  ? `ac-symbol-${color}` : `ac-logo-${color}-wide`}.png`} alt="logo" className={"logo " + (props.className || "")}/>
};
